module.exports = __webpack_public_path__ + "static/media/street-view.19c8e42a.svg";